import { Logo } from "@kirvanobr/logo";
import * as S from "@styles/error-styles";
import Image from "next/image";

import Button from "@components/common/ui/Button";
import CustomThemeProvider from "@providers/CustomThemeProvider";
import { useTheme } from "next-themes";
import Dark404 from "public/assets/error-ilustrations/dark/500-dark.svg";
import Light404 from "public/assets/error-ilustrations/light/500-light.svg";

export default function Custom505() {
  const { theme } = useTheme();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <CustomThemeProvider>
      <S.Container>
        <div>
          <div className="logo">
            <Logo variant="full" fontSize={24} className="text-foreground" />
          </div>
          <span>
            <h1 className="title">Ocorreu um erro inesperado</h1>
            <p className="text">Por favor, tente novamente em instantes.</p>
          </span>

          <Button className="start-button " fullWidth={false} onClick={handleRefresh}>
            Tentar novamente
          </Button>
        </div>

        <div>
          <S.Ilustration>
            <Image alt="Page not working" src={theme === "dark" ? Dark404 : Light404} fill sizes="100%" />
          </S.Ilustration>
        </div>
      </S.Container>
    </CustomThemeProvider>
  );
}
